import script from "./PriceAlerts.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceAlerts.vue?vue&type=script&setup=true&lang=js"

import "./PriceAlerts.vue?vue&type=style&index=0&id=ee5c4d72&lang=scss"

const __exports__ = script;

export default __exports__